//#region Styles
import { Container, CardLinkWrapper, HeroSection, Subtitle } from "./styles";
import { TitleSection } from "components/styles";
//#endregion
//#region Components
import CardLinkItemV2 from "components/CardLinkItem/secondary/CardLinkItemV2";
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
//#endregion
//#region Utils
import { INFORMATION_LINKS } from "./utils/constants";
import { TOOLTIP_PROPS } from "components/CardLinkItem/secondary/utils/constants";
import { userHasPermission } from "config/userPermissions";
import { useEffect, useState } from "react";
//#endregion

const SettingsHome = ({
    userRole
}) => {
    const [filteredInformationLinks, setFilteredInformationLinks] = useState([]);
    useEffect(() => {
        setFilteredInformationLinks(INFORMATION_LINKS.filter(({ id: permission }) => userHasPermission(userRole, permission)));
    }, [userRole]);
    if (filteredInformationLinks.length === 0) 
        return null;
    return (
        <>
        <HelmetUTP title="Config."/>
        <Container>
            <HeroSection>
                <TitleSection textAlign="center">Configuración</TitleSection>
                <Subtitle>
                    Administra los módulos disponibles según tus permisos y entra
                    rápidamente al área que necesites actualizar.
                </Subtitle>
            </HeroSection>
            <CardLinkWrapper>
                {filteredInformationLinks
                .map(item => (
                    <CardLinkItemV2 
                        key={item.id} 
                        variant="secondary"
                        {...item}
                        tooltip={{
                            props: TOOLTIP_PROPS,
                            ...item.tooltip,
                        }}/>
                ))}
            </CardLinkWrapper>
        </Container>
        </>
    );
}

export default SettingsHome;
